import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  successImportItemQty,
  failedImportItemQty,
  clearImportItemsQty
} from '../../../actions/components/import-items-quantity-result';

const initialState = {
  items: []
};

const successImportItemQtyHandler = reduxAction => ({
  [reduxAction.toString()]: (state, { payload }) =>
    set('items', [...state.items, { ...payload, status: 1 }], state)
});

const failedImportItemQtyHandler = reduxAction => ({
  [reduxAction.toString()]: (state, { payload }) =>
    set('items', [...state.items, { ...payload, status: 0 }], state)
});

const clearItemsImportQtyHandler = reduxAction => ({
  [reduxAction.toString()]: set('items', [])
});

export default createReducer(initialState, {
  ...successImportItemQtyHandler(successImportItemQty),
  ...failedImportItemQtyHandler(failedImportItemQty),
  ...clearItemsImportQtyHandler(clearImportItemsQty)
});
